import { sendRequest } from "../sendRequest";

export const createConversation = ({ userId, message }) => {
  return sendRequest("post", `/influencer/chat/conversation`, {
    userId,
    message,
    userType: "brand",
  }).then((res) => res.data);
};
